import { faFileCircleCheck, faRotate, faTag, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default [
    {
        key: 'OwnershipChange',
        id: 'sale',
        title: 'Cambios de nombre',
        icon: <FontAwesomeIcon icon={faRotate} />,
        navLink: '/admin/sales/OwnershipChange'
    },
    {
        key: 'DGTReport',
        id: 'sale',
        title: 'Informes de la DGT',
        icon: <FontAwesomeIcon icon={faFileCircleCheck} />,
        navLink: '/admin/sales/DGTReport',
    },
    {
        key: 'EnviromentalTag',
        id: 'sale',
        title: 'Etiqueta Medio Ambiental',
        icon: <FontAwesomeIcon icon={faTag} />,
        navLink: '/admin/sales/EnviromentalTag',
    },
    {
        key: 'Leads',
        id: 'sale',
        title: 'Leads',
        icon: <FontAwesomeIcon icon={faUser} />,
        navLink: '/admin/leads',
    },
]